import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE, STORE_STORAGE } from '../../_config'

export function* getSentimentTimeline(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SENTIMENT.GET_SENTIMENT_TIMELINE, data, true);
        
        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getSentimentOverall(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SENTIMENT.GET_SENTIMENT_OVERALL, data, true);
        
        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getSentimentBreakdown(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SENTIMENT.GET_SENTIMENT_BREAKDOWN, data, true);
        
        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getSentimentComparison(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SENTIMENT.GET_SENTIMENT_COMPARISON, data, true);
        
        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getReviewVolumn(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SENTIMENT.GET_REVIEW_VOLUMN, data, true);
        
        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getRatingStars(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.SENTIMENT.GET_REVIEW_RATING, data, true);
        
        if (resp.status >= 200 && resp.status < 300) {
            // console.log('resp', resp.data);
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

